import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { User } from '../../modules/common/types/types';

export const accountApi = createApi({
    reducerPath: 'accountApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/account",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getUserInfo: builder.query<User, any>({
            query: () => 'profile',
            transformResponse: (response: { body: User }, meta, arg) => {
                return response.body;
            },
        }),
        logOut: builder.mutation<any, {}>({
            query: () => 'logout',
        }),
        
        checkCompleteProfile: builder.query<boolean, any>({
            query: () => 'check-profile',
            transformResponse: (response: { body: boolean }, meta, arg) => {
                return response.body;
            },
        }),

        verifyAccount: builder.query<any, string>({
            query: (token) => `verify-account/${token}`,
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            },
        }),
    })
})

export const { useLazyGetUserInfoQuery, useLogOutMutation, useLazyCheckCompleteProfileQuery, useLazyVerifyAccountQuery } = accountApi;
export default accountApi;